import { useState } from "react";
import * as React from "react";
import styled, { css } from "styled-components";
import { fadeIn, fadeOut, grow, shrink } from "./Animations.ts";
import { DURATION } from "../Styles/GlobalStyles.ts";

export function usePopup() {
    const [isVisible, setIsVisible] = useState(false);
    const [isFadingOut, setIsFadingOut] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isShrinking, setShrinking] = useState(false);

    const togglePopup = () => {
        if (isOpen) {
            setShrinking(true);
            setTimeout(() => {
                setIsOpen(false);
                setShrinking(false);
            }, DURATION);
        } else {
            setIsOpen(true);
        }

        if (isVisible) {
            setIsFadingOut(true);
            setTimeout(() => {
                setIsVisible(false);
                setIsFadingOut(false);
            }, DURATION);
        } else {
            setIsVisible(true);
        }
    };

    return { isVisible, isFadingOut, isOpen, isShrinking, togglePopup };
}

type PopupProps = {
    isOpen: boolean;
    isShrinking: boolean;
    isVisible: boolean;
    isFadingOut: boolean;
    onClose: () => void;
    children: React.ReactNode;
};

export const Shadow = styled.div<{ isVisible: boolean; isFadingOut: boolean }>`
    z-index: 899;
    position: fixed;
    transform: translate3d(0, 0, 0); // необходимо для работы корректной работы blur
    backdrop-filter: blur(2px);
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
    opacity: 0; /* Initial state to ensure animations work correctly */

    animation: ${({ isFadingOut, isVisible }) =>
        isFadingOut
            ? css`
                  ${fadeOut} ${DURATION}ms forwards;
              `
            : isVisible
              ? css`
                    ${fadeIn} ${DURATION}ms forwards;
                `
              : `none;`};
`;

const Background = styled.div<{ isOpen: boolean; isShrinking: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: var(--border-radius);
    position: absolute;
    width: calc(var(--extension-width) - 2 * var(--spacing-36));
    min-height: 120px;
    max-height: 400px;
    overflow: auto;
    overscroll-behavior: contain;
    padding: var(--spacing-12);

    background-color: var(--background);
    border: var(--border-width) solid var(--border);
    left: 50%;
    right: 0;
    transform: translate(-50%, -5px);
    transform-origin: 0 0;
    z-index: 900;

    animation: ${({ isShrinking, isOpen }) =>
        isShrinking
            ? css`
                  ${shrink} ${DURATION}ms forwards;
              `
            : isOpen
              ? css`
                    ${grow} ${DURATION}ms forwards;
                `
              : `none;`};
`;

export const Modal: React.FC<PopupProps> = ({ isOpen, isShrinking, isVisible, isFadingOut, onClose, children }) => {
    return (
        <>
            {isOpen && <Shadow onClick={onClose} isVisible={isVisible} isFadingOut={isFadingOut} />}
            {isOpen && (
                <Background isOpen={isOpen} isShrinking={isShrinking}>
                    {children}
                </Background>
            )}
        </>
    );
};
